import React from "react";
import useWindowDimensions from "../get-diemensions/UseWindowDiemensions";
import { MenuDisplayHeader } from "../components";
import { useNavigate } from "react-router-dom";

const Legality = () => {
  const { width, height } = useWindowDimensions();
  const navigate = useNavigate();
  return (
    <div style={{ width: width, position: "relative" }}>
      <MenuDisplayHeader
        selected={"legality"}
        onAboutClick={() => navigate("/")}
        onPharmaciesClick={() => navigate("/pharmacies")}
        onPractionersClick={() => navigate("/practioner")}
      />
      Legality
    </div>
  );
};

export default Legality;
